export enum SidebarPolygonTool {
  medianZones = 'median-zones',
  polygonsInMedianZones = 'polygons-in-median-zones',
  polygonsIntersections = 'polygons-intersections',
  auditPolygons = 'audit-polygons',
  auditIntersections = 'audit-intersections',
  polygonTool = 'polygon-tool',
}
